export enum OrderIconsEnum {
  Expired = 'EXPIRED',
  Active = 'ACTIVE',
  Warning = 'WARNING',
}

export type OrderIconsEnumType = keyof typeof OrderIconsEnum;
